<div class="sw-cms-el-config-moorl-accordion">
    <sw-tabs
        class="sw-cms-el-config-image-gallery__tabs"
        default-item="content"
    >
        <template #default="{ active }">
            <sw-tabs-item
                name="content"
                :activeTab="active"
            >
                {{ $tc('sw-cms.elements.general.config.tab.content') }}
            </sw-tabs-item>
            <sw-tabs-item
                name="settings"
                :activeTab="active"
            >
                {{ $tc('sw-cms.elements.general.config.tab.settings') }}
            </sw-tabs-item>
        </template>

        <template #content="{ active }">
            <sw-container v-if="active === 'content'">
                <mt-text-field
                    :label="$tc('sw-cms.elements.moorl-accordion.label.name')"
                    v-model="element.config.name.value"
                />
                <div class="sw-field">
                    <div class="config-moorl_faq_list">
                        <sw-collapse
                            v-for="(entry, index) in element.config.entries.value"
                            :key="index"
                            :ref="'collapse_' + index"
                        >
                            <template #header="{ expanded }">
                                <div
                                    class="collapse-header"
                                    :class="expanded ? 'expanded' : ''"
                                >
                                    <div class="drag-indicator">
                                        <mt-icon name="regular-grip-lines"/>
                                    </div>
                                    <h4>
                                        {{ entry.name ?? 'New entry' }}
                                    </h4>
                                    <div class="collapse-indicator">
                                        <mt-icon
                                            v-if="expanded"
                                            class="sw-media-collapse__button"
                                            name="regular-chevron-down-s"
                                        />
                                        <mt-icon
                                            v-else
                                            class="sw-media-collapse__button"
                                            name="regular-chevron-right-s"
                                        />
                                    </div>
                                </div>
                            </template>

                            <template #content>
                                <div class="collapse-content">
                                    <mt-text-field
                                        :label="$tc('sw-cms.elements.moorl-accordion.label.name')"
                                        v-model="entry.name"
                                    />
                                    <sw-code-editor
                                        v-model:value="entry.content"
                                        mode="twig"
                                        :label="$tc('sw-cms.elements.moorl-accordion.label.content')"
                                        :softWraps="true"
                                    />
                                    <mt-button
                                        variant="danger"
                                        @click.prevent="removeEntry($event, index)"
                                    >
                                        {{ $tc('sw-cms.elements.moorl-accordion.label.remove') }}
                                    </mt-button>
                                </div>
                            </template>
                        </sw-collapse>
                    </div>
                    <div class="config-moorl_faq_actions">
                        <mt-button
                            :block="true"
                            @click="addEntry"
                            variant="ghost"
                        >
                            <span>
                                <mt-icon
                                    name="regular-plus"
                                    :small="true"
                                />
                                {{ $tc('sw-cms.elements.moorl-accordion.label.add') }}
                            </span>
                        </mt-button>
                    </div>
                </div>
            </sw-container>
            <sw-container v-if="active === 'settings'">
                <moorl-select-field
                    v-model:value="element.config.verticalAlign.value"
                    set="flexVerticalAlign"
                />
            </sw-container>
        </template>
    </sw-tabs>
</div>